module.exports = __webpack_public_path__ + "img/pantalla-6-8.e5b39050.png";